import { ReactComponent as NoOfAssignments } from "../../../../../Images/MIIcons/counter.svg";
import { ReactComponent as InProgress } from "../../../../../Images/MIIcons/inprogress.svg";
import { ReactComponent as Completed } from "../../../../../Images/MIIcons/completed.svg";
import { ReactComponent as Received } from "../../../../../Images/MIIcons/received.svg";
import { ReactComponent as ViewAllStatistics } from "../../../../../Images/MIIcons/allstatistics.svg";
import { ReactComponent as Modules } from "../../../../../Images/MIIcons/modules.svg";
import { ReactComponent as Cancelled } from "../../../../../Images/MIIcons/cancelled.svg";
import { ReactComponent as Confirmed } from "../../../../../Images/MIIcons/check.svg";
import { ReactComponent as ShortList } from "../../../../../Images/MIIcons/shortlist.svg";
import { ReactComponent as Chemistry } from "../../../../../Images/MIIcons/chemistry.svg";
import { ReactComponent as Online360 } from "../../../../../Images/MIIcons/360.svg";

export const miIconsAssigner = (label) => {
    const IconsStyle = { width: "100%", fill: "#fff", height: "100%" };
    switch (label) {
      case "no of assignments":
        return <NoOfAssignments style={{ ...IconsStyle }} />;
      case "In progress":
        return <InProgress style={{ ...IconsStyle }} />;
      case "Confirmed":
        return <Confirmed style={{ ...IconsStyle }} />;
      case "Received":
        return <Received style={{ ...IconsStyle }} />;
      case "Chemistry" || label.includes("session"):
        return <Chemistry style={{ ...IconsStyle }} />;
      case "Completed":
        return <Completed style={{ ...IconsStyle }} />;
      case "Shortlist":
        return <ShortList style={{ ...IconsStyle }} />;
      case "View all statistics":
        return <ViewAllStatistics style={{ ...IconsStyle }} />;
      case "Cancelled":
        return <Cancelled style={{ ...IconsStyle }} />;
      case "Online 360":
        return <Online360 style={{ ...IconsStyle }} />;
      default:
        return <Modules style={{ ...IconsStyle }} />;
    }
  };